(function () {
    'use strict';
    
    angular
        .module('searchControllers')
        .directive('focusOnMainSearch', directive);

    directive.$inject = ['$rootScope', '$document'];

    function directive($rootScope, $document) {
        var config = {
            restrict: 'A',
            require: 'ngModel',
            link: link,
        };

        return config;

        function link(scope, element, attrs, ngModel) {
            var onMainSearchActive = scope.$on('main-search-active', onMainSearchActiveHandler)
            var searchWatcher = scope.$watch(function () { return ngModel.$modelValue;}, onSearchChangeHandler)

            // Broadcast a top-search-blur event on blur
            element.on('blur', onBlur);

            scope.$on('$destroy', function () {
                // Deregisters event handlers
                element.off('click', onBlur);
                onMainSearchActive();
                searchWatcher();
            });

            function onBlur(evt) {
                $rootScope.$broadcast('top-search-blur', ngModel.$modelValue);
            }

            function onSearchChangeHandler(newValue, oldValue) {
                if (!newValue && oldValue) {
                    $rootScope.$broadcast('top-search-blur', '');
                }
            }

            function onMainSearchActiveHandler(evt, searchInput) {
                element.focus();
                ngModel.$setViewValue(searchInput);
                ngModel.$modelValue = searchInput;
                ngModel.$render(searchInput);
            };
        }
    }
})();